import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IErknmAgreementTerminate } from 'APIPackage/KnmModule/interfaces/IErknmAgreementTerminate';
import { createTerminationReasonSelectOption } from 'CorePackage/CatalogsModule/common/createTerminationReasonSelectOption';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IPosition } from 'APIPackage/DictionariesModule/interfaces/IPosition';

import { getSelectOption } from './getSelectOption';
import { IErknmFormAgreementTerminate } from '../interfaces/IErknmFormAgreementTerminate';
import { convertAgreementsProsecutorOrganizationToFormValues } from './convertAgreementsProsecutorOrganizationToFormValues';

export const convertAgreementsTerminateToFormValues = (
  terminate: IErknmAgreementTerminate | null,
  state: IRootState,
): IErknmFormAgreementTerminate | undefined => {
  if (!terminate) {
    return undefined;
  }

  let titleSigner: IDictionarySelectOption<IPosition> | undefined;

  if (terminate.titleSigner) {
    if (terminate.titleSigner.dictId) {
      titleSigner = getSelectOption<DictionaryUUIDsEnum.POSITIONS>(
        state,
        terminate.titleSigner.dictId,
        terminate.titleSigner.dictVersionId,
      );
    } else if (terminate.titleSigner.title) {
      titleSigner = {
        label: terminate.titleSigner.title,
        code: '',
        guid: '',
        id: '',
        title: terminate.titleSigner.title,
        value: {
          // @ts-ignore
          dictId: '',
          dictVersionId: '',
          title: terminate.titleSigner.title,
        },
      };
    }
  }

  return {
    terminationReasons: terminate.terminationReasons?.map(terminationReason =>
      createTerminationReasonSelectOption(terminationReason),
    ),
    decisionTerminationAttachment: terminate.decisionTerminationAttachment
      ? [terminate.decisionTerminationAttachment]
      : undefined,
    prosecutorOrganization: convertAgreementsProsecutorOrganizationToFormValues(terminate.prosecutorOrganization),
    fioSigner: terminate.fioSigner || undefined,
    titleSigner,
    whoMadeDecision: terminate.whoMadeDecision || undefined,
  };
};
